import { sendPost } from './dataUtilities';
import env from '../env';

const POST_VERIFY_PHONE = '/users/user/PHONE/verify';

export const postVerifyPhone = (phoneNumber: string) => sendPost(
  env.userBaseUrl + POST_VERIFY_PHONE, {}, { value: phoneNumber },
);

export default postVerifyPhone;
